import React, { useState } from "react";
import useAppContext from "state/AppContext";
import { ChevronDownIcon, ChevronUpIcon, HomeIcon } from "@heroicons/react/24/solid";

export default function AdminSettingsOverview() {
  const appContext = useAppContext();
  const customerName = appContext.currentUser.firstName;
  const [showContent, setShowContent] = useState(true);

  function handleToggle() {
    setShowContent(!showContent);
  }

  const containerStyles = "w-full mb-[30px] bg-white rounded-xl shadow-md blur-2 text-opacity-15 spread-0";
  const buttonStyles = `w-full flex items-stretch justify-between py-4 px-6 ${showContent ? "border-b border-b-gray-300" : ""}`;

  const morningGreeting = `Good morning, ${customerName}!`;
  const afterNoonGreeting = `Good afternoon, ${customerName}!`;
  const eveningGreeting = `Good evening, ${customerName}!`;
  const titleGreeting =
    new Date().getHours() < 12 ? morningGreeting : new Date().getHours() < 17 ? afterNoonGreeting : eveningGreeting;

  return (
    <div className={containerStyles}>
      <button className={buttonStyles} onClick={handleToggle}>
        <header className="flex items-center flex-1">
          <div className="bg-blue-600 rounded-lg p-1 flex items-center justify-center h-[25px] w-[25px] mr-2">
            <HomeIcon className="h-3 w-3 text-white" />
          </div>
          <h3 className="text-lg font-semibold">Settings Overview</h3>
        </header>
        <footer className="flex items-center ">
          {showContent ? <ChevronUpIcon className="block h-4 w-4" /> : <ChevronDownIcon className="block h-4 w-4" />}
        </footer>
      </button>
      {showContent ? (
        <section className="p-6">
          <h2 className="text-xl font-bold mb-2">{titleGreeting}</h2>
          <p className="text-sm leading-6">This is your personalized Settings page.</p>
        </section>
      ) : null}
    </div>
  );
}
